export const BASE_URL = "https://crosscheck-be-dev.onrender.com";
